import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
  ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
};

export const userPool = new CognitoUserPool(poolData);

export const cognitoConfig = {
  region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '',
};

export default userPool;
